import { render, staticRenderFns } from "./Marketplace.vue?vue&type=template&id=7f8c53cd&scoped=true"
import script from "./Marketplace.vue?vue&type=script&lang=js"
export * from "./Marketplace.vue?vue&type=script&lang=js"
import style0 from "./Marketplace.vue?vue&type=style&index=0&id=7f8c53cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8c53cd",
  null
  
)

export default component.exports